import React,{useEffect,useState} from "react"
import EditButton from "./EditButton";
import Api from "./Api";
import { useGlobal } from "./Reducer";
import _ from "lodash";

export default (props)=>{

    const [gs,ga]=useGlobal();
    const [POLL,setPOLL]=useState({})
    const [OPTIONS,setOPTIONS]=useState({});
    const [sel,setSel]=useState(0);
    const [err,setErr]=useState();
    const [success,setSuccess]=useState(false);

    const submitVote=()=>{

            if(gs.adminMode)
            {
                return;
            }
        setErr(null);
        setSuccess(null);
          if(sel==0)
          {
              setErr("Please select a option");
              return;
          }
          Api.vote(sel).then(result=>{
                    if(result=="VOTED")
                    {
                        setErr("You have already voted!");
                        return;
                    }
                    else
                    {
                        setSuccess(true);
                        ga.setVoted(true);
                        Api.recordAnalytics(gs.appData.id,"VOTE",POLL.title,"");
                    }


          })      

    }


    useEffect(()=>{
            ga.loading(true);
        
            Api.getSelectedPollAndOptions(gs.appData.id).then(({POLL,OPTIONS})=>{
                    setPOLL(POLL);
         
                    setOPTIONS(OPTIONS);
                


            }).finally(()=>{
                ga.loading(false);
            });;
    },[gs.appData.active_poll_id])




    return (<div className="whitebg boxed poll_news" ng-show="featured_poll">
    <div id="poll_title_here" className="lvl1 graytext ng-binding" >
This month's question

    </div>
   {err && <div className="alert alert-danger" role="alert" style={{marginTop:10}} id="poll_alert_error">
       {err}
    </div>}
  {success &&  <div className="alert alert-success" role="alert"  style={{marginTop:10}} id="poll_alert_done">
      Your Vote is registered!
    </div>}
    <div className="changeable  hvr-shrink" ref_tag="poll_setter" id="poll_setter" 
    style={{position:'absolute',right:4,top:-22}}

    

    data-toggle="tooltip" data-placement="left" title="Change poll Settings">
        {props.editButton}
    </div>
        <div id="active_poll" >
        <div className="poll_title" id="poll_title" >{POLL.title}</div>
    <div>
        
      
    {_.map(OPTIONS,(option=>{
        return (  <div key={option.id+"XXXX"} style={{display:"flex"}} className="field-block"> 
        
        <div style={{marginRight:10,marginTop:3}}>
        <input type="radio" 
            id={"radio"+option.id}
           value={option.id}
            checked={option.id==sel}
                onChange={(e)=>{
                                
                                    setSel(e.target.value);
                                
                }}
        name="option"   aria-required="true"/>
        </div>
        <label className="" htmlFor={"radio"+option.id}    >   {option.title} </label>
        
         </div>);
    }))}
     
  
 
       
       </div>
       
        <button onClick={submitVote} className="btn btn-info orange pollsubmit" style={{borderRadius:5}}>Submit</button></div>
  </div>);
}